import React from 'react';
import { Box, Container, Grid, Typography, IconButton } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = () => {
  return (
    <Box sx={{ bgcolor: '#1a237e', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>          
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              Informasi Kontak
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <WhatsAppIcon sx={{ mr: 1 }} />
              <Typography 
                variant="body2" 
                component="a" 
                href="https://wa.me/6282122428628"
                target="_blank"
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                +62 821-2242-8628
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <InstagramIcon sx={{ mr: 1 }} />
              <Typography 
                variant="body2"
                component="a"
                href="https://www.instagram.com/mentengrent"
                target="_blank"
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                @mentengrent
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <LocationOnIcon sx={{ mr: 1, mt: 0.5 }} />
              <Typography variant="body2">
                Jl. Dr. KRT Radjiman Widyodiningrat RT. 011/012 No. 27A, Jatinegara, Kec. Cakung, Kota Jakarta Timur
              </Typography>
            </Box>
          </Grid>          
        </Grid>
        <Typography variant="body2" sx={{ mt: 4, textAlign: 'center' }}>
          © {new Date().getFullYear()} Menteng Rent. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;